import React from 'react'

import Tooltip from '../../../../components/atoms/Tooltip'

import useStyles from './styles'

const ArticleTitle = ({ depth, children }) => {
  const ref = React.useRef(null)
  const [isOverflown, setIsOverflown] = React.useState(false)

  const classes = useStyles({ depth })

  React.useEffect(() => {
    const element = ref.current
    setIsOverflown(element.scrollWidth > element.clientWidth)
  }, [])

  return (
    <Tooltip title={children} disabled={!isOverflown} arrow>
      <div ref={ref} className={classes.root}>
        {children}
      </div>
    </Tooltip>
  )
}

export default ArticleTitle
